module.exports = __webpack_public_path__ + "media/327.ff6b2a71.mp4";